var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "8563c17d5667c70aa95c04548f9bc26f52f2b20c"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["self-care@mallpay"] = {
  id: "8563c17d5667c70aa95c04548f9bc26f52f2b20c"
};